import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch } from 'react-router-dom';
import ApplicationsTable from '../../components/ApplicationsTable';
import ApplicationSettings from '../../components/ApplicationSettings';

const ApplicationsManager = ({
  match,
  env,
  user,
  ...rest
}) => (
  <Switch>
    <Route path={`${match.url}/`} exact render={props => <ApplicationsTable env={env} user={user} {...props} />} />
    <Route path={`${match.url}/:id`} exact render={props => <Redirect to={`${props.match.url}/settings`} {...props} />} />
    <Route path={`${match.url}/:id/settings`} render={props => <ApplicationSettings {...rest} {...props} />} />
  </Switch>
);

ApplicationsManager.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
  env: PropTypes.string,
};

ApplicationsManager.defaultProps = { env: undefined };

export default ApplicationsManager;
